
type ProcessEssayPaginationProps = {
  currentPage: number;
  totalPages: number;
  totalItems: number;
  itemsPerPage: number;
  onPageChange: (page: number) => void;
}

export function ProcessEssayPagination({
  currentPage,
  totalPages,
  totalItems,
  itemsPerPage,
  onPageChange
}: ProcessEssayPaginationProps) {
    const startItem = (currentPage - 1) * itemsPerPage + 1;
  const endItem = Math.min(currentPage * itemsPerPage, totalItems);

  if (totalPages <= 1) {
    return null;
  }
  return (
    <div className="mt-4 d-flex justify-content-between align-items-center">
      <p className="text-muted mb-0" style={{ fontSize: '14px' }}>
        Mostrando <span className="fw-medium">{startItem}</span> a <span className="fw-medium">{endItem}</span> de <span className="fw-medium">{totalItems}</span> resultados
      </p>
      
      <div className="d-flex gap-1">
        <button
          className="btn btn-outline-secondary btn-sm px-3"
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
          style={{ 
            fontSize: '14px',
            opacity: currentPage === 1 ? 0.5 : 1
          }}
        >
          Anterior
        </button>
        
        <button
          className="btn btn-outline-secondary btn-sm px-3"
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          style={{ 
            fontSize: '14px',
            opacity: currentPage === totalPages ? 0.5 : 1
          }}
        >
          Próximo
        </button>
      </div>
    </div>
  );
}
